<template>
  <div class="orders-section">
    orders section
    <OrdersTable  :items="companyOrders"/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OrdersTable from "./components/Tables/ordersTable"
export default {
    components:{
        OrdersTable
    },
  methods: {
    ...mapActions({
      companyFirstOrders: "Order/companyFirstOrders",
      companyPaginateOrders: "Order/companyPaginateOrders"
    }),

  },
  computed: {
    userProfile() {
      return this.$store.state.Auth.userProfile;
    },
    companyOrders() {
      return this.$store.state.Order.companyOrders;
    }
  },
  watch: {
    "$route.query": {
      handler(query) {
        if (query.page) {
          const limit = 20;
          this.companyPaginateOrders(limit);
        } else {
          const limit = 20;
          this.companyFirstOrders({limit})
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style>
</style>